module.exports = __webpack_public_path__ + "static/img/mobilepay-logo.9e606d60.svg";